module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1037-96c4a4973c7606307d317a99058436da.png";